import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const SmsConfiguartionBasicInfoComponent = ({ selectedSmsConfigurations, handleInnerFormChange }: any) => {
    return (
        <>


            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>




                        <InputContainer
                            label="Service Provider"
                            labelField="ServiceProvider"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Clickatell.ServiceProvider',
                                );
                            }}
                            type="text"
                            value={selectedSmsConfigurations?.Clickatell?.ServiceProvider}
                        />
                        <InputContainer
                            label="Api Key"
                            labelField="ApiKey"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Clickatell.ApiKey',
                                    selectedSmsConfigurations?.Clickatell,
                                );
                            }}
                            type="text"
                            value={selectedSmsConfigurations?.Clickatell?.ApiKey}
                        />

                        <InputContainer
                            label="Base Url"
                            labelField="BaseUrl"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Clickatell.BaseUrl',
                                    selectedSmsConfigurations?.Clickatell,
                                );
                            }}
                            type="text"
                            value={selectedSmsConfigurations?.Clickatell?.BaseUrl}
                        />

                        <InputContainer
                            label="Active"
                            name="IsActive"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'Clickatell.IsActive',
                                    selectedSmsConfigurations?.Clickatell
                                )
                            }}
                            type="checkbox"
                            value={selectedSmsConfigurations?.Clickatell?.IsActive}
                        />

                    </div>
                }
                expandedPanel="selectedSmsConfigurations"
                headerTitle="Clickatell"
            />
        </>
    )
}
export default SmsConfiguartionBasicInfoComponent;
